export enum BillingTypeEnum {
  BILLABLE = 'BILLABLE',
  NON_BILLABLE = 'NON_BILLABLE',
  UNDEFINED = 'UNDEFINED',
}
